<template>
  <section>
    <TheArticleList :articles="themes.data" linkPath="theme" displayType="card">
      <template>
        <TheListTitle :listTitle="articleTitle" prefix="tour" />
        <ArticleFilter>
          <TheSelect
            @onChange="(value) => handleChange('locale', value)"
            @onReset="handleReset('locale')"
            :options="localeOptions"
            placeholder="行政區"
          />
          <TheSelect
            @onChange="(value) => handleChange('topic', value)"
            @onReset="handleReset('topic')"
            :options="topicOptions"
            placeholder="主題"
          />
        </ArticleFilter>
      </template>
    </TheArticleList>
    <TheListPagination
      category="themes"
      :pages="themes"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
// import { lazyloading } from '@/utils/lazyloading';
import TheListTitle from '@/components/list/TheListTitle';
import ArticleFilter from '@/components/list/ArticleFilter';
import TheArticleList from '@/components/list/TheArticleList';
import TheListPagination from '@/components/list/TheListPagination';
import TheSelect from '@/components/TheSelect';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TheThemes',
  metaInfo() {
    return {
      title: '旅遊導覽',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: '臺南宗教藝術-旅遊導覽',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            '看完臺南的廟宇藝術，別忘了也要去附近走走，來場臺南廟宇小旅行。',
        },
      ],
    };
  },
  data() {
    return {
      locale: null,
      topic: null,
    };
  },
  computed: {
    ...mapGetters(['themes', 'themeFilter', 'productionHostname']),
    articleTitle() {
      return getArticleString('theme', 'headline');
    },
    productionWholeReference() {
      return `${this.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    localeOptions() {
      return this.toOptions('NS_LOCALE');
    },
    topicOptions() {
      return this.toOptions('NS_TOPIC');
    },
  },
  async mounted() {
    Promise.all([this.getThemes(), this.getThemeFilter()]);
    // await lazyloading();
  },
  methods: {
    ...mapMutations(['setArticleParams']),
    async getThemes() {
      // 載入藝品列表頁，以 API 資料作為初始值
      const params = {};
      this.locale && (params.locale = this.locale.value);
      this.topic && (params.topic = this.topic.value);
      this.setArticleParams(params)

      try {
        await this.$store.dispatch('getThemes', params);
      } catch (e) {
        console.error(e);
      }
    },
    async getThemeFilter() {
      // 載入篩選的資料
      try {
        await this.$store.dispatch('getThemeFilter');
      } catch (e) {
        console.error(e);
      }
    },
    handleChange(field, value) {
      this[field] = value;
      this.getThemes();
    },
    handleReset(field) {
      this[field] = null;
      this.getThemes();
    },
    toOptions(filed) {
      if (this.themeFilter[filed]) {
        return this.themeFilter[filed].map(({ name, id }) => ({
          label: name,
          value: id,
        }));
      } else {
        return [];
      }
    },
  },
  components: {
    TheListTitle,
    ArticleFilter,
    TheArticleList,
    TheListPagination,
    TheSelect,
  },
};
</script>

<style lang="scss" scoped></style>
